import React from 'react';
import { Box } from '@mui/material';
import StyledTag from './StyledTag/StyledTag';

interface FilterTagButtonProps {
  label: string;
  count?: number;
  onClick: () => void;
  disabled?: boolean;
}

export default function FilterTagButton({
  label,
  count,
  onClick,
  disabled = false
}: FilterTagButtonProps) {
  const displayLabel = count && count > 1 ? `${label} +${count - 1}` : label;

  return (
    <Box
      onClick={disabled ? undefined : onClick}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        cursor: disabled ? 'default' : 'pointer',
        '&:hover': {
          '& .MuiBox-root': {
            backgroundColor: disabled ? '#E3F2FD' : '#E3F2FDDD'
          }
        }
      }}
    >
      <StyledTag
        label={displayLabel}
        disabled={disabled}
        showArrow={false}
        isOpen={false}
      />
    </Box>
  );
}
